import { render, staticRenderFns } from "./SetoresTable.vue?vue&type=template&id=57bb94e6"
import script from "./SetoresTable.vue?vue&type=script&lang=js"
export * from "./SetoresTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports